/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ReimbursementType } from './ReimbursementType';
import {
    ReimbursementTypeFromJSON,
    ReimbursementTypeFromJSONTyped,
    ReimbursementTypeToJSON,
} from './ReimbursementType';

/**
 * 
 * @export
 * @interface PayerContract
 */
export interface PayerContract {
    /**
     * 
     * @type {string}
     * @memberof PayerContract
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PayerContract
     */
    payor_id: string;
    /**
     * 
     * @type {string}
     * @memberof PayerContract
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PayerContract
     */
    facility_ids: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PayerContract
     */
    type: PayerContractTypeEnum;
    /**
     * 
     * @type {ReimbursementType}
     * @memberof PayerContract
     */
    reimbursement_type: ReimbursementType;
    /**
     * 
     * @type {string}
     * @memberof PayerContract
     */
    s3_key?: string;
    /**
     * 
     * @type {string}
     * @memberof PayerContract
     */
    s3_access_url?: string;
    /**
     * 
     * @type {string}
     * @memberof PayerContract
     */
    expiry_date: string;
    /**
     * 
     * @type {string}
     * @memberof PayerContract
     */
    processing_status?: PayerContractProcessingStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PayerContract
     */
    processing_error?: PayerContractProcessingErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof PayerContract
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof PayerContract
     */
    created_by?: string;
}


/**
 * @export
 */
export const PayerContractTypeEnum = {
    Commercial: 'Commercial',
    ManagedMedicare: 'Managed Medicare',
    ManagedMedicaid: 'Managed Medicaid',
    Medicare: 'Medicare',
    Medicaid: 'Medicaid',
    Other: 'Other',
    PrivatePay: 'Private Pay'
} as const;
export type PayerContractTypeEnum = typeof PayerContractTypeEnum[keyof typeof PayerContractTypeEnum];

/**
 * @export
 */
export const PayerContractProcessingStatusEnum = {
    Created: 'created',
    InProgress: 'in_progress',
    Completed: 'completed',
    Error: 'error'
} as const;
export type PayerContractProcessingStatusEnum = typeof PayerContractProcessingStatusEnum[keyof typeof PayerContractProcessingStatusEnum];

/**
 * @export
 */
export const PayerContractProcessingErrorEnum = {
    Error: 'error',
    InsufficientInfo: 'insufficient_info',
    WrongPayer: 'wrong_payer'
} as const;
export type PayerContractProcessingErrorEnum = typeof PayerContractProcessingErrorEnum[keyof typeof PayerContractProcessingErrorEnum];


/**
 * Check if a given object implements the PayerContract interface.
 */
export function instanceOfPayerContract(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "payor_id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "facility_ids" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "reimbursement_type" in value;
    isInstance = isInstance && "expiry_date" in value;

    return isInstance;
}

export function PayerContractFromJSON(json: any): PayerContract {
    return PayerContractFromJSONTyped(json, false);
}

export function PayerContractFromJSONTyped(json: any, ignoreDiscriminator: boolean): PayerContract {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'payor_id': json['payor_id'],
        'name': json['name'],
        'facility_ids': json['facility_ids'],
        'type': json['type'],
        'reimbursement_type': ReimbursementTypeFromJSON(json['reimbursement_type']),
        's3_key': !exists(json, 's3_key') ? undefined : json['s3_key'],
        's3_access_url': !exists(json, 's3_access_url') ? undefined : json['s3_access_url'],
        'expiry_date': json['expiry_date'],
        'processing_status': !exists(json, 'processing_status') ? undefined : json['processing_status'],
        'processing_error': !exists(json, 'processing_error') ? undefined : json['processing_error'],
        'created_at': !exists(json, 'created_at') ? undefined : json['created_at'],
        'created_by': !exists(json, 'created_by') ? undefined : json['created_by'],
    };
}

export function PayerContractToJSON(value?: PayerContract | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'payor_id': value.payor_id,
        'name': value.name,
        'facility_ids': value.facility_ids,
        'type': value.type,
        'reimbursement_type': ReimbursementTypeToJSON(value.reimbursement_type),
        's3_key': value.s3_key,
        's3_access_url': value.s3_access_url,
        'expiry_date': value.expiry_date,
        'processing_status': value.processing_status,
        'processing_error': value.processing_error,
        'created_at': value.created_at,
        'created_by': value.created_by,
    };
}

